import { getDns, getItem, setItem } from "utils";

export const authConfig = {
  secretKey: getItem("companyId"),
  boundId: "br.com.atlas",
};

export async function applyStyles(dns) {
  const { data: productDns } = await getDns({
    dns,
  });

  const productStylesheet = productDns[0].stylesheet;

  if (productDns) {
    await setItem("companyName",  productDns[0].name);
    await setItem("iosAppUrl",  productDns[0].iosAppUrl);
    await setItem("androidAppUrl",  productDns[0].androidAppUrl);
    await setItem("stylesheet", productStylesheet);
    await setItem("companyId", productDns[0].companyId);

    const privacyPolicy = productDns[0].assets?.privacyPolicy;
    const termsConditions = productDns[0].assets?.termsConditions;
    const termsRepresentation = productDns[0].assets?.termsRepresentation;

    await setItem(
      "privacyPolicy",
      privacyPolicy ||
        "https://atlas-uploads-documents-dev.s3.sa-east-1.amazonaws.com/documents/pdf/e3cfb10b-dad5-49aa-b2af-7dae4da9d732-01-12-2021-08-37-03.pdf"
    );
    termsConditions && (await setItem("termsConditions", termsConditions));
    termsRepresentation && (await setItem("termsRepresentation", termsRepresentation));

    // let cssVars = getAllCSSVariableNames();
    // let cssStyles = document.querySelector(":root");
    let innerStyle = ":root {";

    Object.keys(productStylesheet).forEach((element) => {
      if (element.split("-")[0] === "image") {
        innerStyle = innerStyle.concat(
          `--${element}: url(${productStylesheet[element]}); `
        );
      } else {
        innerStyle = innerStyle.concat(
          `--${element}: ${productStylesheet[element]}; `
        );
      }
    });

    innerStyle = innerStyle.concat("}");

    let newStyles = document.createElement("style");
    document.head.append(newStyles);

    newStyles.innerHTML = innerStyle;
  }
}
